import React, {useEffect} from 'react';
import { Grid } from "@mui/material";
import { useDispatch} from "react-redux";
import MUIDataTable, {MUIDataTableColumnDef} from "mui-datatables";
import CustomToolbar from "./CustomToolbar";
import {createTablePaginationWithFirstLast} from "../TablePaginationWithFirstLast";



interface iCadTabela {
    isOpen: boolean,
    dialogState: (param:boolean, recId?: number ) => void,
    title: string,
    data: object[],
    columns: MUIDataTableColumnDef[],
    getCadastro:  () => void

}


const CadTabela = (props : iCadTabela) => {

    const dispatch = useDispatch();

    useEffect(() =>{
       
        dispatch(props.getCadastro);
    },[props.title]);



    // @ts-ignore
    const options = {
        rowsPerPage: 50,
        rowsPerPageOptions: [15,30,50,100,],
        customFooter: createTablePaginationWithFirstLast([15,30,50,100]),
        enableNestedDataAccess: ".",
        textLabels: {
            body: {
                noMatch: "Sem registros",
                toolTip: "Ordenar",
                columnHeaderTooltip: (column: any) => `Ordenar por ${column.label}`
            },
            pagination: {
                next: "Próxima Pagina",
                previous: "Página Anterior",
                rowsPerPage: "Registros por página:",
                displayRows: "de",
            },
            toolbar: {
                search: "Pesquisar",
                downloadCsv: "Download CSV",
                print: "Imprimir",
                viewColumns: "Ver colunas",
                filterTable: "Filtrar",
            },
            filter: {
                all: "Todos",
                title: "Filtros",
                reset: "Reiniciar",
            },
            viewColumns: {
                title: "Mostrar colunas",
                titleAria: "Mostrar/ignorar colunas",
            },
            selectedRows: {
                text: "registros selecionados",
                delete: "Apagar",
                deleteAria: "Apagar registros selecionados",
            },
        },

        download: false,
        print: false,

        onRowClick: (rowData: string[],
                     rowMeta: { dataIndex: number, rowIndex: number }) => {
            props.dialogState(true, parseInt(rowData[0]) );
        },

        customToolbar: (selectedRows : any) => (
            <CustomToolbar
                dialogState={props.dialogState}
            />
        )
    };
    
    return (


            <Grid container >


                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <MUIDataTable
                            title={props.title}
                            data={props.data}
                            columns={props.columns}
                            options={options}/>
                    </Grid>

            </Grid>

    );
}

export default (CadTabela);
